





















import { createNamespacedHelpers } from 'vuex';
import { login, handleAPIError } from '../api';
import router from '../router';
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class Login extends Vue {
  private form = {
    username: '',
    password: '',
  };
  private rules = {
    username: [
      {
        required: true,
        message: 'This field is required',
        trigger: 'change',
      },
    ],
    password: [
      {
        required: true,
        message: 'This field is required',
        trigger: 'change',
      },
    ],
  };
  private error = false;

  private async submit() {
    this.error = false;
    try {
      await (this.$refs.form as any).validate();
    } catch (e) {
      return;
    }
    let success = null;
    try {
      success = await login(this.form.username, this.form.password);
    } catch (e) {
      handleAPIError(e);
    }
    if (success) {
      router.push({ name: 'page', params: { page: 'index' } });
    } else {
      this.error = true;
    }
  }
}
